import * as Backbone from "backbone";
import {InsecureCachingCollection} from "./_BaseCollection";

export class AppCollection extends InsecureCachingCollection<Backbone.Model> {
    url = () => {
        return window.location.origin + '/api/v1/apps';
    };

    comparator = (model) => {
        return model.get('app_group_order');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Apps.ts